import * as React from 'react';
import { useLocation, useNavigate } from 'react-router';

import { Breakpoint, Button, Dialog, DialogContent, DialogTitle, IconButton, Stack, Typography } from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import CancelIcon from '@mui/icons-material/Cancel';

export const Modal = ({title, description, children, cancel, buttons, alertComponent, maxWidth='md', background}: 
    {title: string, description?: React.ReactNode | React.ReactNode[], children?: React.ReactNode[] | React.ReactNode, cancel?: boolean, buttons?: React.ReactNode[], alertComponent?: React.ReactNode, maxWidth?: Breakpoint, background?: boolean}) => {
    
    const location = useLocation();
    const navigate = useNavigate();
    const openState = background ?? location.state?.background;

    const handleClose = () => {
        navigate(-1);
    }

    return <Dialog open={openState} onClose={handleClose} fullWidth maxWidth={maxWidth}>
        <DialogTitle>
            {title}
            <IconButton onClick={handleClose} sx={{position: 'absolute', right: 8, top: 8}}>
                <CloseIcon />
            </IconButton>
        </DialogTitle>

        <DialogContent>
            <Stack direction='column' spacing={20}>
                {alertComponent}
                <Typography variant='body2' display={!description?'none':'block'}>{description}</Typography>
                {children}
                <Stack direction='row' display={!cancel && !buttons?'none':'flex'} justifyContent='space-between'>
                    {<Button onClick={handleClose} startIcon={<CancelIcon/>}>{"Cancel"}</Button>}
                    {buttons}
                </Stack>
            </Stack>
        </DialogContent>
    </Dialog>
}

export const NonRouterModal = ({title, description, children, cancel, buttons, alertComponent, openState, setOpenState, maxWidth='md'}: 
    {title: string, description?: React.ReactNode | React.ReactNode[], children?: React.ReactNode[] | React.ReactNode, cancel?: boolean, buttons?: React.ReactNode[], alertComponent?: React.ReactNode, openState: boolean, setOpenState: (state: boolean) => void , maxWidth?: Breakpoint}) => {
    
    const handleClose = () => {
        setOpenState(false);
    }

    return <Dialog open={openState} onClose={handleClose} fullWidth maxWidth={maxWidth}>
        <DialogTitle>
            {title}
            <IconButton onClick={handleClose} sx={{position: 'absolute', right: 8, top: 8}}>
                <CloseIcon />
            </IconButton>
        </DialogTitle>

        <DialogContent>
            <Stack direction='column' spacing={20}>
                {alertComponent}
                <Typography variant='body2' display={!description?'none':'block'}>{description}</Typography>
                {children}
                <Stack direction='row' display={!cancel && !buttons?'none':'flex'} justifyContent='space-between'>
                    {cancel !== false && <Button onClick={handleClose} startIcon={<CancelIcon />}>{"Cancel"}</Button>}
                    {buttons}
                </Stack>
            </Stack>
        </DialogContent>
    </Dialog>
}